import { type NewStory } from 'types/api/story'

export function formatStoryFromSharedMedia(parsedMedia: any) {
    let story: NewStory = {}
    if (parsedMedia) {
        if (parsedMedia[0].post) {
            if (parsedMedia[0].post.photos[0]) {
                story.photo = {
                    path: parsedMedia[0].post.photos[0].url,
                    orientation: parsedMedia[0].post.photos[0].orientation
                }
                if (
                    parsedMedia[0].post.photos[0].text.value &&
                    parsedMedia[0].post.photos[0].text.x &&
                    parsedMedia[0].post.photos[0].text.y
                ) {
                    story = {
                        ...story,
                        text: {
                            value: parsedMedia[0].post.photos[0].text.value,
                            x: parsedMedia[0].post.photos[0].text.x,
                            y: parsedMedia[0].post.photos[0].text.y
                        }
                    }
                }
            } else if (parsedMedia[0].post.videos[0]) {
                story.videos = [
                    {
                        path: parsedMedia[0].post.videos[0].url,
                        orientation: parsedMedia[0].post.videos[0].orientation,
                        duration: parsedMedia[0].post.videos[0].duration ?? 0,
                        video_exif: parsedMedia[0].post.videos[0].video_exif
                    }
                ]
            }
        }
    }
    if (parsedMedia[0].story) {
        if (parsedMedia[0].story.image_src) {
            story = {
                ...story,
                photo: {
                    path: parsedMedia[0].story.image_src,
                    orientation: parsedMedia[0].story.image_orientation
                }
            }
        }
        if (parsedMedia[0].story.text) {
            story = {
                ...story,
                text: {
                    value: parsedMedia[0].post.photos[0].text.value,
                    x: parsedMedia[0].story.text.x,
                    y: parsedMedia[0].story.text.y
                }
            }
        }
        if (parsedMedia[0].story.video_src) {
            story.videos = [
                {
                    path: parsedMedia[0].story.video_src,
                    orientation: parsedMedia[0].story.video_orientation,
                    duration: parsedMedia[0].story.duration ?? 0,
                    video_exif: parsedMedia[0].story.video_exif
                }
            ]
        }
        if (parsedMedia[0].story.poll) {
            story = {
                ...story,
                poll: {
                    type: parsedMedia[0].story.poll.type,
                    question: parsedMedia[0].story.poll.question,
                    answers:
                        parsedMedia[0].story.poll.answers_count.length > 0
                            ? parsedMedia[0].story.poll.answers_count.map(
                                  (item: any) => item.text
                              )
                            : []
                }
            }
        }
    }
    return story
}
